const formatKm = (m: server.dto.Distance, decimals: number): string => {
  if (!decimals) decimals = 0;

  const rounded = m.meter / 1000;
  return `${rounded.toFixed(decimals)} km`;
};

export const isImperial = (locale: string) => {
  return locale.endsWith("en-US");
}

export {
  formatKm
};